import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function Footer({ domain, pokName, institutionalSite, country = 'en', t }) {
    const kycRedirectLink = (root, type) => window.open(`${root}/redirect/${type}?country=${country}`, '_blank');
    const pokLogo = pokName.toLowerCase() === 'pok' ? 'POK_Logo_primary.png' : 'certva_logo.png';
    const footerText = `© ${new Date().getFullYear()} ${pokName}`;
    const styleLink = {
        color: '#98D0EF',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '22px',
        fontFamily: 'Lato, Poppins',
        cursor: 'pointer',
        textDecoration: 'none !important',
    };
    const styleBody1 = {
        color: '#FFF',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '22px',
        fontFamily: 'Lato, Poppins',
    };

    const styleBody2 = {
        color: '#FFF',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '19px',
        fontFamily: 'Lato, Poppins',
    };

    const tyc = (
        <Stack spacing={1}>
            <Typography sx={styleBody1}>{t('commons.footer.aboutUs')}</Typography>
            <a
                style={{ textDecoration: 'none' }}
                href={institutionalSite + '/faqs'}
                rel="noopener noreferrer"
                target="_blank"
            >
                <Typography sx={styleLink}>{t('commons.footer.faqs')}</Typography>
            </a>
            <a
                onClick={() => kycRedirectLink(import.meta.env.VITE_KYC_API, 'tc')}
                rel="noopener noreferrer"
                target="_blank"
            >
                <Typography sx={styleLink}>{t('commons.footer.termAndConditions')}</Typography>
            </a>
            <a
                onClick={() => kycRedirectLink(import.meta.env.VITE_KYC_API, 'pp')}
                rel="noopener noreferrer"
                target="_blank"
            >
                <Typography sx={styleLink}> {t('commons.footer.privacyData')}</Typography>
            </a>
        </Stack>
    );

    const contact = (
        <>
            <Typography sx={styleBody1}>{t('commons.footer.contact')}</Typography>
            <a
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                href={`mailto:${t('commons.pok_email', { domain: domain })}`}
            >
                <Typography sx={styleLink}>{t('commons.pok_email', { domain: domain })}</Typography>
            </a>
            <Stack spacing={3} direction={'row'} pt={3} sx={{ alignSelf: { xs: 'center', sm: 'start' } }}>
                <a
                    href="https://www.linkedin.com/company/pok-proof-of-knowledge/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={`${institutionalSite}/images/footer/ic-linkedin.svg`} alt="Linkedin" />
                </a>
                <a href="https://twitter.com/POKdiplomas" target="_blank" rel="noopener noreferrer">
                    <img src={`${institutionalSite}/images/footer/ic-twit.png`} alt="Twitter" />
                </a>
            </Stack>
        </>
    );
    return (
        <>
            <footer>
                <Stack>
                    <Grid container spacing={2}>
                        <Grid item md={1} />
                        <Grid item md={2.5} sx={{ display: { xs: 'none', md: 'block' } }}>
                            <Stack direction="row">
                                <Stack spacing={1} ml={3}>
                                    <Box sx={{ display: { md: 'block', xs: 'none' } }}>
                                        <a
                                            href={institutionalSite}
                                            target={institutionalSite === window.location.origin ? '_self' : '_blank'}
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                style={{ height: 38, width: 'auto' }}
                                                src={`${institutionalSite}/images/_${pokLogo}`}
                                                alt="Logo"
                                            />
                                        </a>
                                    </Box>
                                    <Box sx={{ display: { md: 'block', xs: 'none' }, paddingTop: 1 }}>
                                        <Typography sx={styleBody2}>{t('commons.footer.allRights')}</Typography>
                                        <Typography sx={styleBody2}>{footerText}</Typography>
                                    </Box>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={0} sx={{ display: { md: 'none', xs: 'block' } }}>
                            <Stack alignItems="center" spacing={1}>
                                <img
                                    style={{ height: 38 }}
                                    src={`${institutionalSite}/images/_${pokLogo}`}
                                    alt="Logo"
                                />
                                <Stack py={3} direction={'row'} spacing={4}>
                                    <a
                                        href="https://site.imsglobal.org/certifications/amelay-corporation-sa-pok/proof-of-knowledge "
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={`${institutionalSite}/images/footer/logo-1edtech-cert.png`}
                                            width="72px"
                                            loading="lazy"
                                            height="72px"
                                            alt="Edtech"
                                        />
                                    </a>
                                    <a
                                        href="https://www.holoniq.com/notes/2024-latin-america-edtech-100"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={`${institutionalSite}/images/footer/holon.png`}
                                            height="72px"
                                            width="72px"
                                            loading="lazy"
                                            alt="Holon Iq"
                                        />
                                    </a>
                                </Stack>
                                <img
                                    src={`${institutionalSite}/images/footer/elm.png`}
                                    width="180"
                                    alt="ELM"
                                    loading="lazy"
                                />
                            </Stack>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={0}
                            sx={{
                                display: { xs: 'inline', md: 'none' },
                                textAlign: { xs: 'center' },
                                mb: 3,
                            }}
                        >
                            <Stack mt={2}>{tyc}</Stack>
                        </Grid>
                        <Grid item md={2.5}>
                            <Stack sx={{ textAlign: { xs: 'center', sm: 'left' }, mb: 2 }}>
                                <Typography sx={styleBody1}>{t('commons.footer.offices')}</Typography>
                                <Grid container mb={2}>
                                    {['ar', 'br', 'ca', 'cl', 'co', 'us', 'es', 'in', 'mx', 'pe', 'pt', 'uy'].map(
                                        (x) => (
                                            <Grid item md={6} xs={6} key={x}>
                                                <Typography
                                                    sx={{
                                                        color: '#FFF',
                                                        fontSize: 16,
                                                        fontWeight: 400,
                                                        fontFamily: 'Lato, Poppins',
                                                    }}
                                                    mt={1}
                                                >
                                                    {t(`commons.footer.country.${x}`)}
                                                </Typography>
                                            </Grid>
                                        ),
                                    )}
                                </Grid>
                            </Stack>
                        </Grid>
                        <Grid item md={3} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
                            <Stack>
                                <Box>{tyc}</Box>
                                <Stack pt={3}>{contact}</Stack>
                            </Stack>
                        </Grid>
                        <Grid item md={0} xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
                            <Stack spacing={1} sx={{ textAlign: 'center' }}>
                                {contact}
                                <Stack sx={{ display: { xs: 'inline', sm: 'none' }, pt: 2 }}>
                                    <Typography sx={styleBody2}>{t('commons.footer.allRights')}</Typography>
                                    <Typography sx={styleBody2}>{footerText}</Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item md={3} sx={{ display: { xs: 'none', md: 'block' } }}>
                            <Stack>
                                <Stack direction={'row'} spacing={4}>
                                    <a
                                        href="https://site.imsglobal.org/certifications/amelay-corporation-sa-pok/proof-of-knowledge "
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={`${institutionalSite}/images/footer/logo-1edtech-cert.png`}
                                            width="104px"
                                            height="104px"
                                            loading="lazy"
                                            alt="Edtech"
                                        />
                                    </a>
                                    <a
                                        href="https://www.holoniq.com/notes/2024-latin-america-edtech-100"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={`${institutionalSite}/images/footer/holon.png`}
                                            height="104px"
                                            width="104px"
                                            loading="lazy"
                                            alt="Holon Iq"
                                        />
                                    </a>
                                </Stack>
                                <Box mt={6}>
                                    <img
                                        src={`${institutionalSite}/images/footer/elm.png`}
                                        width="235px"
                                        height="50px"
                                        alt="ELM"
                                        loading="lazy"
                                    />
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>
            </footer>
        </>
    );
}
